<template>
    <div>
        <div class="flex items-center justify-between scaffold-body-small text-ink" :class="{ 'mb-2.5': !hideScore }">
            <span>{{ label }}</span>
            <span v-if="!hideScore">
                <I18nT keypath="assessments.results.scoreRow.scoreOutOf">
                    <template #score>
                        <span class="font-bold">{{ formatNumber(avg, "one-decimal") || "—" }}</span>
                    </template>
                    <template #maxScore>{{ formatNumber(maxScore) }}</template>
                </I18nT>
            </span>
        </div>
        <!-- Both bars share one cream track: self on top, others below, widths
             pinned to the same max score so the gap reads at a glance. -->
        <div v-if="!hideScore" class="bar-track">
            <div v-if="showSelfComparison && selfAvg !== null && selfAvg !== undefined" class="bar bar--self" :style="{ width: (selfAvg / maxScore) * 100 + '%' }"></div>
            <div class="bar bar--others" :style="{ width: ((avg ?? 0) / maxScore) * 100 + '%' }"></div>
        </div>
        <div v-if="!hideScore && showSelfComparison && selfAvg !== null && selfAvg !== undefined" class="scaffold-details-small text-ink-muted mt-2.5">
            {{ t("assessments.results.scoreRow.selfScore", { score: formatNumber(selfAvg, "one-decimal") }) }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { formatNumber } from "~vue/utils/formatNumber";
import { I18nT, useI18n } from "vue-i18n";

interface Props {
    label: string;
    avg: number | null | undefined;
    selfAvg: number | null | undefined;
    maxScore: number;
    showSelfComparison: boolean;
    // A section whose statements are reverse-keyed has no meaningful average:
    // keep the label, drop the number and bars.
    hideScore?: boolean;
}

withDefaults(defineProps<Props>(), { hideScore: false });

const { t } = useI18n();
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .bar-track {
        @apply flex flex-col gap-1 w-full bg-surface-sunken rounded-md p-2;
    }

    .bar {
        @apply h-[17px] rounded-md;
    }

    .bar--self {
        @apply bg-assessment-self;
    }

    .bar--others {
        @apply bg-assessment-others;
    }
}
</style>
